import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface ShareTemplateDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    templateName: string | undefined;
}

const ShareTemplateDialog: React.FC<ShareTemplateDialogProps> = ({ open, onClose, onConfirm, templateName }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="share-dialog-title"
            aria-describedby="share-dialog-description"
        >
            <DialogTitle id="share-dialog-title">Template Delen?</DialogTitle>
            <DialogContent>
                <DialogContentText id="share-dialog-description">
                    Weet je zeker dat je de template "{templateName}" wilt delen met de organisatie?
                    Deze actie kan niet ongedaan worden gemaakt.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button
                    onClick={() => {
                        onConfirm();
                        onClose(); // Close dialog after confirmation
                    }}
                    color="primary"
                    autoFocus
                >
                    Delen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ShareTemplateDialog;
